import React from 'react'
import './style.scss'

const DashboardLayout = ({Navigation, Content, Footer}) => {
    return(
        <div className="full-public-page-container">
            {Navigation ? <Navigation/>:null}
            {Content ? <Content/>:null}
            {Footer ? <Footer/>:null}
        </div>
    )
}

export default DashboardLayout